export const downloadUri = (uri: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = uri;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();

  // Clean up
  window.URL.revokeObjectURL(uri);
  document.body.removeChild(link);
};

export const downloadFile = (data: string, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  downloadUri(url, fileName);
};
